"use strict";
exports.__esModule = true;
exports.useAccordionContext = exports.Accordion = void 0;
var Accordion_1 = require("./Accordion");
var AccordionContext_1 = require("./AccordionContext");
exports.useAccordionContext = AccordionContext_1.useAccordionContext;
var AccordionItem_1 = require("./AccordionItem");
var Accordion = Object.assign(Accordion_1.Accordion, { Item: AccordionItem_1.AccordionItem });
exports.Accordion = Accordion;
//# sourceMappingURL=index.js.map